import { Node, mergeAttributes } from "@tiptap/core";
import { entitiesPath } from "@/react/helpers/urlHelpers/entitiesPaths";
import { entitiesNodeConfiguration as originalEntitiesNodeConfiguration } from "@circle-react-uikit/TipTap/Extensions/CustomExtensions/Entities";

export const EntitiesExtension = Node.create<{
  sgIdToObjectMap: Record<string, unknown>;
  onLocalSgidToObjectMapChange: ({
    sgid,
    object,
  }: {
    sgid: string;
    object: unknown;
  }) => void;
  isPreviewMode?: boolean;
}>({
  ...originalEntitiesNodeConfiguration,
  parseHTML: () => [{ tag: "a" }],
  renderHTML: function ({ HTMLAttributes }) {
    const {
      options: { sgIdToObjectMap, isPreviewMode },
    } = this;
    const appliedSgid = HTMLAttributes["data-sgid"] as string;
    const object = sgIdToObjectMap?.[appliedSgid];

    if (!object) return ["span"];

    const { type, slug, space_slug, name, section_id, id } = object as {
      type: string;
      slug: string;
      space_slug: string;
      name: string;
      section_id?: number;
      id?: number;
    };

    const displayText = type.toLowerCase() === "space" ? `#${name}` : name;

    const href = new URL(
      entitiesPath({ type, slug, space_slug, section_id, lesson_id: id }),
      window.location.origin,
    ).toString();

    return [
      "a",
      mergeAttributes(HTMLAttributes, {
        href,
        target: "_blank",
        onclick: isPreviewMode ? "event.preventDefault();" : undefined,
      }),
      displayText,
    ];
  },
});
